import React from 'react'
import { Link } from 'gatsby'

import styled from 'styled-components'
import {
  calculateResponsiveSize,
  calculateMobileResponsiveSize,
  mediaMax,
} from 'styles/media-queries'

import HeaderLogo from 'icons/logo.svg'
import HeaderLogoMini from 'icons/logo-mini.svg'

export const Wrapper = styled.header`
  height: ${calculateResponsiveSize(80)};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  right: 0;
  z-index: 10;
  padding: ${calculateResponsiveSize(25)} ${calculateResponsiveSize(40)}
    ${calculateResponsiveSize(25)} ${calculateResponsiveSize(20)};
  display: flex;
  align-items: center;
  transition: 0.6s;

  &:before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    transition: 0.5s;
    background: var(--light);
  }
  &:not(.opened).home.hide {
    display: none;
  }

  &.header-white:before {
    background: transparent;
  }
  &.header-black:before {
    background: var(--black);
  }
  &.opened:before {
    background: transparent;
  }
  &:not(.home) {
    opacity: 1 !important;
    transform: translate(0px, 0%) !important;
  }
  ${mediaMax('mobile')} {
    height: auto;
    min-height: ${calculateMobileResponsiveSize(72)};
    padding: ${calculateMobileResponsiveSize(21)}
      ${calculateMobileResponsiveSize(20)} ${calculateMobileResponsiveSize(21)}
      ${calculateMobileResponsiveSize(20)};
    flex-wrap: wrap;

    &.opened.menu {
      transform: translate(0px, 0%) !important;
    }
    & .select-lang {
      display: none;
    }
  }
`

export const Logo = styled((props) => <Link {...props} />)`
  width: ${calculateResponsiveSize(101.25)};
  height: ${calculateResponsiveSize(30)};
  -webkit-mask: url(${HeaderLogo}) no-repeat;
  -webkit-mask-size: contain;
  background: var(--light);
  display: flex;
  margin-right: ${calculateResponsiveSize(40)};
  transition: 0.5s;
  transition: transform 1s, opacity 1s;

  z-index: 10;
  position: absolute;
  transform: translateY(${calculateResponsiveSize(50)});

  opacity: 0;
  top: ${calculateResponsiveSize(25)};

  .header-white & {
    background: var(--light);
  }
  .header-black & {
    background: var(--light);
  }
  .opened & {
    background: var(--light);
    transform: translateY(${calculateResponsiveSize(0)});
    opacity: 1;
    transition: transform 1s, opacity 1s;
  }
  ${mediaMax('mobile')} {
    width: ${calculateMobileResponsiveSize(101)};
    height: ${calculateMobileResponsiveSize(30)};
    margin-right: ${calculateMobileResponsiveSize(0)};
    top: ${calculateMobileResponsiveSize(20)};
    transform: translateY(${calculateMobileResponsiveSize(40)});
  }
`
export const LogoMini = styled((props) => <Link {...props} />)`
  top: ${calculateResponsiveSize(20)};

  opacity: 1;

  width: ${calculateResponsiveSize(42.56)};
  height: ${calculateResponsiveSize(40)};
  -webkit-mask: url(${HeaderLogoMini}) no-repeat;
  -webkit-mask-size: contain;
  background: var(--blue);
  display: flex;
  z-index: 10;
  position: absolute;
  transition: 0.5s;
  transition: transform 1s, opacity 1s;

  .header-white & {
    background: var(--light);
  }
  .header-black & {
    background: var(--light);
  }

  .opened & {
    transform: translateY(${calculateResponsiveSize(-10)});

    opacity: 0;
    transition: transform 1s, opacity 1s;
  }
  ${mediaMax('mobile')} {
    width: ${calculateMobileResponsiveSize(42.6)};
    height: ${calculateMobileResponsiveSize(40)};
    top: ${calculateMobileResponsiveSize(15)};
    .opened & {
      transform: translateY(${calculateMobileResponsiveSize(-20)});
    }
  }
`

export const Links = styled.ul`
  margin-left: auto;

  display: flex;
  gap: ${calculateResponsiveSize(30)};
  align-items: center;
  z-index: 10;
  position: relative;
  li:last-child {
    margin-left: ${calculateResponsiveSize(-24)};
  }
  ul li:last-child {
    margin-left: ${calculateResponsiveSize(0)};
  }
  ${mediaMax('mobile')} {
    gap: ${calculateMobileResponsiveSize(30)};
    li:last-child {
      margin-left: ${calculateMobileResponsiveSize(-24)};
    }
  }
`
export const Li = styled.li`
  position: relative;
  &.li-contact {
    min-width: ${calculateResponsiveSize(60)};
  }
  ${mediaMax('mobile')} {
    &.li-contact {
      display: none;
    }
  }
`

export const LinkItem = styled((props) => <Link {...props} />)`
  font-family: 'Basis Grotesque Pro';
  font-size: ${calculateResponsiveSize(10)};
  font-weight: 400;
  line-height: ${calculateResponsiveSize(16)};
  letter-spacing: ${calculateResponsiveSize(2)};
  text-align: center;
  color: var(--blue);

  text-transform: uppercase;
  transition: 0.5s;

  &,
  &:hover,
  &:active,
  &:visited {
    color: var(--blue);
  }
  .header-black &,
  .header-white & {
    color: var(--light);
    &:hover,
    &:active,
    &:visited {
      color: var(--light);
    }
  }

  .opened & {
    color: var(--light);
    &:hover,
    &:active,
    &:visited {
      color: var(--light);
    }
  }
`

export const ContactLink = styled.button`
  font-family: 'Basis Grotesque Pro';
  font-size: ${calculateResponsiveSize(10)};
  font-weight: 400;
  line-height: ${calculateResponsiveSize(16)};
  letter-spacing: ${calculateResponsiveSize(2)};
  text-align: center;
  border: none;
  color: var(--blue);
  background: none;

  text-transform: uppercase;
  cursor: pointer;

  .header-white &,
  .header-black & {
    color: var(--light);
  }
  .opened & {
    color: var(--light);
  }
  & span {
    transition: 0.5s;
  }
  & span:last-child {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
  }
  & span.hide {
    opacity: 0;
  }
`
